<template>
	<div id="domains" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head title="Emails" subtitle="Password Security Portal"></dash-head>

				<div v-if="!showAddEmail">
					<list-group  class="mt-4 mb-3" heading="Breached Credentials" :showSearch="true" @search-changed="searchChanged">
						<list-group-item 
							v-for="email in results" 
							:key="email.value" 
							:description="email.value" 
							:detail="email.statusDetail" 
							:url="'/email/' + email.value">
						</list-group-item>
					</list-group>


					<div class="row">
						<div class="col-md-6">
							<table-pagination :page="1" :pages="3" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
						</div>
						<div class="col-md-6">
							<div class="text-right">
								<button v-if="!isInRole('ReadOnly')" class="btn btn-outline-primary px-3" @click.prevent="showHideAddEmail(true)">Add Email</button>
							</div>
						</div>
					</div>
				</div>

				<div v-if="showAddEmail">
					<hr class="mt-3">

					<add-email-form @close-add-email="showHideAddEmail(false)"></add-email-form>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import ListGroup from './ListGroup'
	import ListGroupItem from './ListGroupItem'
	import AddEmailForm from './AddEmailForm'
	import TablePagination from './TablePagination'

	import store from '../state'

	export default {
		name: 'EmailPanel',
		components: {SideBar, DashHead, ListGroup, ListGroupItem, AddEmailForm, TablePagination},
		data() {
			return {
				pageSize:12,
				currentPage:1,
				showAddEmail: false,
				search: ''
			}
		},
		methods: {
			showHideAddEmail(value) {
				this.showAddEmail = value;
			},
			pageChanged(value) {
				this.currentPage = value;
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return;
				return store.state.user.roles.indexOf(role) > -1;
			},
			searchChanged(value) {
				this.search = value.toLowerCase();
			},
		},
		computed: {
			emails () {
				return store.state.emails;
			},
			filteredEmails () {
				if (!this.search) return this.emails;
				return this.emails.filter(email => email.value.includes(this.search));
			},
			totalRows() {
				return this.filteredEmails.length;
			},
			results() {
				const start = (this.currentPage-1) * this.pageSize;		
				const data = this.filteredEmails;
				const results = [];								

				for (var email of data.slice(start, start + this.pageSize)) {
					results.push(email);
				}

				return results;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/EmailPanel.vue